import { Table, Badge, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

import { CompanyPolicyNudge } from "../../interfaces/models/CompanyPolicyNudge";

import { CompanyPolicyNudgeStatusOptions, CompanyPolicyNudgeStatus } from "../../helper/constants";
import { ReformatDate } from "../../helper/Utilities";
import Loading from "../Loading";
import { CompanyPolicy } from "../../interfaces/models/CompanyPolicy";

interface Props {
  policy: CompanyPolicy
  loading: boolean;
  nudges: CompanyPolicyNudge[];
  hasCRUD: boolean;
  isOnProcess?: boolean;
  handleOpenSingleApprove?: (nudge: CompanyPolicyNudge) => void;
  handleOpenEditNudge?: (nudge: CompanyPolicyNudge) => void;
  handleOpenDeleteNudge?: (nudge: CompanyPolicyNudge) => void;
  handleRegenerateNudge?: (id: string, onGenerated: boolean) => void;
  handleOpenNudgeHistory: (nudge: CompanyPolicyNudge) => void;
}

export default function CompanyPolicyNudgeTable({ policy, loading, nudges, hasCRUD, isOnProcess, handleOpenDeleteNudge, handleOpenEditNudge, handleOpenNudgeHistory, handleOpenSingleApprove, handleRegenerateNudge}: Props) {

  return (
    <Table bordered className="bg-white" responsive>
        <thead>
          <tr>
            <th>No.</th>
            <th>Title & Description</th>
            <th>Created At</th>
            <th>Created By</th>
            <th>Status</th>
            <th>AI Generated?</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>

          {
          loading ? 
            <tr>
              <td colSpan={7}>
                <Loading />
              </td>
            </tr>
          :
            nudges.length === 0 ? 
            <tr>
              <td colSpan={7} className="text-center">
                No Nudges Found
              </td>
            </tr>
            :
            nudges.map((item, index) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>
                  <div className="font-weight-bold">{item.title}</div>
                  <div style={{ width: 250, maxWidth: 250, wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "pre-wrap" }}>{item.description}</div>
                </td>
                <td>{ReformatDate(item.created_at)}</td>
                <td>{item.created_by_user?.name}</td>
                <td>
                  <Badge color={CompanyPolicyNudgeStatusOptions[item.status - 1].color} >{CompanyPolicyNudgeStatusOptions[item.status - 1].name}</Badge>
                </td>
                <td>{item.ai_generated ? "YES" : "NO"}</td>
                <td>
                  <UncontrolledDropdown size="sm">
                    <DropdownToggle caret color="primary" disabled={isOnProcess}>
                      Actions
                    </DropdownToggle>
                    <DropdownMenu container="body">
                      {
                        hasCRUD && 
                        <>
                          {
                            item.status === CompanyPolicyNudgeStatus.INREVIEW &&
                            <DropdownItem onClick={() => handleOpenSingleApprove(item)}>
                              <small>Approve</small>
                            </DropdownItem>
                          }
                          <DropdownItem onClick={() => handleOpenEditNudge(item)}>
                            <small>Update</small>
                          </DropdownItem>
                          <DropdownItem onClick={() => handleOpenDeleteNudge(item)}>
                            <small>Delete</small>
                          </DropdownItem>
                          {
                            policy && policy.policy_meta_data && 
                            <DropdownItem onClick={() => handleRegenerateNudge(item._id, false)}>
                              <small>Regenerate</small>
                            </DropdownItem>
                          }
                        </>
                      }
                      {/* <DropdownItem onClick={() => {setIsHistoryModalOpen(true); setSelectedNudgeHistory(item);}}> */}
                      <DropdownItem onClick={() => handleOpenNudgeHistory(item)}>
                        <small>History</small>
                      </DropdownItem>
                     
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </td>
              </tr>
            ))
          }
        </tbody>
      </Table>
  )

}

